import React, { useMemo } from 'react';

import { Card } from '../../../components';
import './styles.css';

export default function Offers(props) {
  const { remoteStates: { space, offers } } = props;

  const sortedOffers = useMemo(() => offers?.length > 0 && offers
    .sort((a, b) => ((a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0)))
    .sort((a, b) => (a.type === 'scheduled_delivery' ? 0 : (!a.availableStock && b.availableStock ? 1 : (a.availableStock && !b.availableStock ? -1 : 0)))),
  [offers]);

  return (
    <section>
      {
        space?.status === 'inactive' && (
          <div className="inactive-indicator-text">
            <p>Não estou recebendo pedidos no momento, mas você ainda pode ver minhas ofertas.</p>
          </div>
        )
      }

      <div className="offers-container">
        <section className="offers-container">
          {
            sortedOffers?.length > 0
              ? sortedOffers
                .map((offer) => <Card key={offer.id} offer={offer} />)
              : (
                <div className="no-offers">
                  {/* <p>{notFound ? `Produtor @${nickname} não encontrado.` : 'Este produtor ainda não possui ofertas.'}</p> */}
                </div>
              )
          }
        </section>
      </div>
    </section>
  );
}
